import axios from 'axios';
import LocalForage from 'localforage';
import swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Accounts } from './api/accounts';
import { Auth } from './api/auth';
import { Home } from './api/home';
import { Calendar } from './api/calendar';
import { Calendar2 } from './api/calendar2';
import { ContactInfo } from './api/contact-info';
import { Daemons } from './api/daemons';
import { Fines } from './api/fines';
import { Plugin } from './api/plugin';
import { Reports } from './api/reports';
import { ReportArchives } from './api/repot-archives';
import { Staff } from './api/staff';
import { Statistics } from './api/statistics';
import { Transfers } from './api/transfers';
import { Users } from './api/users';
import { Gifts } from './api/gifts';
import { Payers } from './api/payers';
import { Dashboard } from './api/dashboard';
import { GeneralProfiles } from './api/general-profile';
import { SharedLinks } from './api/shared-links';
import { Chats } from './api/chats';

const modal = withReactContent(swal);

const http = axios.create({ baseURL: '/api/v1' });

export const env = {
  api: {
    auth: new Auth(http),
    home: new Home(http),
    reports: new Reports(http),
    accounts: new Accounts(http),
    users: new Users(http),
    daemons: new Daemons(http),
    plugin: new Plugin(http),
    staff: new Staff(http),
    statistics: new Statistics(http),
    calendar: new Calendar(http),
    calendar2: new Calendar2(http),
    fines: new Fines(http),
    transfers: new Transfers(http),
    reportArchives: new ReportArchives(http),
    contactInfo: new ContactInfo(http),
    gifts: new Gifts(http),
    payers: new Payers(http),
    dashboard: new Dashboard(http),
    generalProfiles: new GeneralProfiles(http),
    sharedLinks: new SharedLinks(http),
    chats: new Chats(http)
  },
  storage: LocalForage.createInstance({
    version: 1.0,
    name: 'synctool',
    storeName: 'primary'
  }),
  alert: swal,
  modal: function(options) {
    return modal.fire({
      showCloseButton: false,
      showCancelButton: false,
      showConfirmButton: false,
      ...options
    });
  },
  http
};
